export default __webpack_public_path__ + "static/media/DownArrow.fb179dab.svg";